module.exports = __webpack_public_path__ + "img/fx.16b8eab4.jpg";